/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ScaleDisplayRouteImport } from './routes/scale-display'
import { Route as NoteQuizRouteImport } from './routes/note-quiz'
import { Route as FeedbackRouteImport } from './routes/feedback'
import { Route as ChordsRouteImport } from './routes/chords'
import { Route as R404RouteImport } from './routes/_404'
import { Route as IndexRouteImport } from './routes/index'

const ScaleDisplayRoute = ScaleDisplayRouteImport.update({
  id: '/scale-display',
  path: '/scale-display',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/scale-display.lazy').then((d) => d.Route))
const NoteQuizRoute = NoteQuizRouteImport.update({
  id: '/note-quiz',
  path: '/note-quiz',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/note-quiz.lazy').then((d) => d.Route))
const FeedbackRoute = FeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/feedback.lazy').then((d) => d.Route))
const ChordsRoute = ChordsRouteImport.update({
  id: '/chords',
  path: '/chords',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/chords.lazy').then((d) => d.Route))
const R404Route = R404RouteImport.update({
  id: '/_404',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_404.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/chords': typeof ChordsRoute
  '/feedback': typeof FeedbackRoute
  '/note-quiz': typeof NoteQuizRoute
  '/scale-display': typeof ScaleDisplayRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/chords': typeof ChordsRoute
  '/feedback': typeof FeedbackRoute
  '/note-quiz': typeof NoteQuizRoute
  '/scale-display': typeof ScaleDisplayRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_404': typeof R404Route
  '/chords': typeof ChordsRoute
  '/feedback': typeof FeedbackRoute
  '/note-quiz': typeof NoteQuizRoute
  '/scale-display': typeof ScaleDisplayRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/chords' | '/feedback' | '/note-quiz' | '/scale-display'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/chords' | '/feedback' | '/note-quiz' | '/scale-display'
  id:
    | '__root__'
    | '/'
    | '/_404'
    | '/chords'
    | '/feedback'
    | '/note-quiz'
    | '/scale-display'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  R404Route: typeof R404Route
  ChordsRoute: typeof ChordsRoute
  FeedbackRoute: typeof FeedbackRoute
  NoteQuizRoute: typeof NoteQuizRoute
  ScaleDisplayRoute: typeof ScaleDisplayRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/scale-display': {
      id: '/scale-display'
      path: '/scale-display'
      fullPath: '/scale-display'
      preLoaderRoute: typeof ScaleDisplayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/note-quiz': {
      id: '/note-quiz'
      path: '/note-quiz'
      fullPath: '/note-quiz'
      preLoaderRoute: typeof NoteQuizRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chords': {
      id: '/chords'
      path: '/chords'
      fullPath: '/chords'
      preLoaderRoute: typeof ChordsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_404': {
      id: '/_404'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  R404Route: R404Route,
  ChordsRoute: ChordsRoute,
  FeedbackRoute: FeedbackRoute,
  NoteQuizRoute: NoteQuizRoute,
  ScaleDisplayRoute: ScaleDisplayRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
